export class UpdateWorkspaceLoggingSettingsInput {
    'deliveryRoleArn';
    'cloudwatchEnabled';
    'cloudwatchLogGroupName';
    's3Enabled';
    's3Uri';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deliveryRoleArn",
            "baseName": "deliveryRoleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchLogGroupName",
            "baseName": "cloudwatchLogGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Enabled",
            "baseName": "s3Enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3Uri",
            "baseName": "s3Uri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceLoggingSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
